

require('../accessibility/directive');

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,

        scope: {
            show: '=?',
            showCloseButton: '=?',
            enableCloseOnEscape: '=?',
            onClose: '=?',
            enableMobileInterstitial: '@?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },

        controller: function controller($scope) {
            $scope.animate = false; // Don't animate until triggered
            $scope.showOverlay = $scope.show;

            var escapeKeyHandler = function escapeKeyHandler($event) {
                if ($event.keyCode === 27) {
                    // Escape key maps to keycode 27
                    $scope.hideModal();
                }
            };

            if ($scope.enableCloseOnEscape) {
                // Handle escape button as close button click
                $(document).bind('keyup', escapeKeyHandler);
            }

            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;

                $(document).unbind('keyup', escapeKeyHandler);

                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        },

        link: function link($scope, elem, attrs) {
            // HACK: without this check, the modal slides down/fades out upon it being rendered
            $scope.$watch('show', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    // When the show prop changes
                    $scope.animate = true; // Ensure the modal is animated
                }
            });
        }
    };
});

_squid.$registerDirective;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/modal/directive.js
// module id = ./components/xo-ui-components/src/modal/directive.js
// module chunks = 1